module.exports = __webpack_public_path__ + "667697af005502ba25900cc37f8f093d.fbx";